import { Grid, useTheme } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import { Base } from ".";
import { NavType } from "../../types/navType";

interface Props {
  type: NavType;
  active?: boolean;
  onClick?: () => void;
}

const NavButton: React.FC<Props> = (props) => {
  const { type, onClick, active } = props;
  const theme = useTheme();
  return (
    <Link
      to={`/${type}`}
      style={{ textDecoration: "none", color: "black" }}
      onClick={onClick}
    >
      <Grid
        container
        direction={"row"}
        alignItems={"center"}
        justifyContent={{ xs: "flex-start", md: "center" }}
        columnSpacing={{ xs: 2, md: 0 }}
        sx={{
          color: theme.palette.text.primary,
          textDecoration: active ? "underline" : "none",
        }}
      >
        <Grid>
          <Base.Text
            text={type.charAt(0).toUpperCase() + type.slice(1)}
            variant="h4"
          />
        </Grid>
      </Grid>
    </Link>
  );
};

export default NavButton;
